import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function NoOrganizationPage() {
  const { signOut } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 p-6">
      <div className="max-w-md rounded-2xl border border-white/10 bg-slate-900 p-8 text-center">
        <h1 className="text-xl font-semibold text-white">No organization assigned</h1>
        <p className="mt-3 text-sm text-slate-300">
          Your account is not linked to a company yet. Contact your platform administrator to be
          added to an organization.
        </p>
        <button
          type="button"
          onClick={() => void signOut()}
          className="mt-6 rounded-lg bg-violet-600 px-4 py-2 text-sm font-medium text-white hover:bg-violet-500"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

export function RequireOrganization({ children }: { children?: React.ReactNode }) {
  const { isLoading, hasOrganization, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-300">
        Loading…
      </div>
    );
  }

  if (user && !hasOrganization) {
    return <NoOrganizationPage />;
  }

  if (children) return <>{children}</>;
  return <Outlet />;
}

export function RequireOrgOwner({ children }: { children?: React.ReactNode }) {
  const { orgRole } = useAuth();
  if (orgRole !== "owner" && orgRole !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (children) return <>{children}</>;
  return <Outlet />;
}

export function RequireOrgManager({ children }: { children?: React.ReactNode }) {
  const { orgRole } = useAuth();
  if (orgRole !== "owner" && orgRole !== "admin" && orgRole !== "manager") {
    return <Navigate to="/" replace />;
  }
  if (children) return <>{children}</>;
  return <Outlet />;
}
